import { getAllUserOrganizations } from "Api/users/getOrganizations.request";
import { getFeatureFlag } from "Reducers/featureFlags";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

type LoadOrganizationProps = {
  userId: string;
};

export const loadOrganizations = createAppAsyncThunk(
  "organizations/loadOrganizations",
  ({ userId }: LoadOrganizationProps) =>
    getAllUserOrganizations(userId, {
      sort: "label",
      page: {
        size: 100
      }
    }),
  {
    condition({ userId }) {
      const organizationEnabled = getFeatureFlag("ENABLE_ORGANIZATION");
      return !!userId && organizationEnabled;
    }
  }
);
